import { ArrowLeft, ChevronUp } from "lucide-react";
import { useState } from "react";
import PodcastImg from "../../assets/images/PodcastTwo.png";
import { useTranslation } from "react-i18next";

const PodcastBox = ({ podcast, seePodcasts, rssFnc, children }) => {
    const [seeVids, setSeeVids] = useState(false);
    const { t } = useTranslation();
    return (
        <div className="rounded-lg mb-4 p-1 border border-[#EBEBEB]">
            <div className="bg-[#EBEBEB45] p-3 rounded-t-lg grid grid-cols-[29%_69%] gap-4">
                <div className="w-full h-32 max-xl:h-full">
                    <img src={podcast?.image || PodcastImg} alt={podcast?.title} className="rounded-lg object-cover h-full w-full" />
                </div>
                <div className="text-start">
                    <p className="text-xl font-bold no-pm">{podcast?.title}</p>
                    <button className="underline text-secondary-tw"
                        onClick={() => rssFnc()}
                    >
                        {t('podcasts.download')}
                    </button>
                </div>
            </div>

            <hr style={{ margin: 0 }} />

            {/* desc */}
            <article className="text-start p-3" dangerouslySetInnerHTML={{ __html: podcast?.description }} />

            <button className="w-full flex items-end justify-end gap-1 pb-2 px-2 text-secondary-tw"
                onClick={() => {
                    setSeeVids(prev => !prev);
                    seePodcasts({
                        id: podcast?.id,
                        title: podcast?.title
                    });
                }}
            >
                <span className="underline-offset-4 underline">
                    {t('podcasts.show-vids')}
                </span>
                <span className="block max-lg:hidden">
                    <ArrowLeft size={22} color="var(--secondary-color)" />
                </span>
                <span className="block lg:hidden">
                    <ChevronUp size={22} color="var(--secondary-color)" className={`${seeVids ? '' : 'rotate-180'}`} />
                </span>
            </button>
            <section
                className={`lg:hidden block ${seeVids ? 'block' : 'hidden'
                    }`}
            >
                <p className="text-start font-bold">{t('podcasts.vids-of')} :</p>
                <section className="space-y-3">
                    {children}
                </section>
            </section>
        </div>
    )
}
export default PodcastBox;